import { render, staticRenderFns } from "./RestoreManifestModal.vue?vue&type=template&id=1826a112"
import script from "./RestoreManifestModal.vue?vue&type=script&lang=ts"
export * from "./RestoreManifestModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports